import { render, staticRenderFns } from "./MentionsLegales.vue?vue&type=template&id=bf5bacc4&scoped=true"
import script from "./MentionsLegales.vue?vue&type=script&lang=js"
export * from "./MentionsLegales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5bacc4",
  null
  
)

export default component.exports